export default __webpack_public_path__ + "static/media/shutterstock_338471630_distribuidores.53e6622b.webp";